export default "__VITE_ASSET__BNOG_WJV__"